import React from 'react'

export const META_FR: metaType = {
  articleid: '109848954398',
  title: 'Tout savoir sur les dioxines',
  lead:
    'Certaines dioxines sont hautement toxiques. Persistantes, ces molécules se fixent dans les sols. Comment se forment-elles et se diffusent-elles? Où se déposent-elles? Pourquoi sont-elles dangereuses? Réponses ci-dessous.',
  authors: 'Dominique Botti, Jürg Candrian, Sebastian Broschinski',
  date: 'Dernière actualisation, le 19 août 2021',
  credits: [
    ['Illustrations', 'Jürg Candrian, Sebastian Broschinski'],
    ['Texte, documentation', 'Roland Gamp, Dominique Botti'],
    ['Conception', 'Sebastian Broschinski']
  ],
  star: (
    <>
    * Cet indice ne révèle pas une, mais plusieurs dioxines. Une pollution est le résultat d’un cocktail de ces substances toxiques. Il n’y en a pas une, mais des centaines différentes. Toutes ne sont pas dangereuses.
    </>
  )
}
export const TEXT_FR: textType[] = [
  {
    illu: require('images/dioxin_01.svg'),
    ground: { y: 90, color: '#efece0' },

    annotations: [
      {
        text: (
          <>
            <b>30 usines </b> d’incinération (UIOM) en Suisse
          </>
        ),
        pos: { x: 2, y: 55 },
        align: 'right',
        maxWidth: 40,
        arrow: {
          type: 'right_bottom',
          pos: { right: '-30px', bottom: '-30px' }
        }
      },
      {
        text: (
          <>
            <b>De 250 à près de 2 grammes</b> de dioxines émises par an
          </>
        ),
        pos: { x: 65, y: 45 },
        arrow: { type: 'left_top', pos: { left: 0, top: '-30px' } }
      }
    ],
    title: 'Les déchets: quel poison!',
    text: (
      <>
        Il y a 30 usines d’incinération des ordures ménagères (UIOM) actives en
        Suisse. En 2020, elles ont brûlé 4 071 643 tonnes de déchets. La
        combustion produit de l’énergie qui est exploitée sous forme de vapeur,
        de chaleur, d’électricité. L’année dernière, les UIOM helvétiques ont
        exporté 5748 gigawattheures. Le brûlage génère des polluants, comme les
        dioxines, les furanes, etc. Ces molécules se retrouvent dans les fumées
        qui, s’il n’y a pas de filtre, se dispersent dans l’environnement. Les
        usines de première génération, construites au milieu du 20e siècle,
        étaient polluantes. Installé dans les années 1980, un système de
        nettoyage des fumées a réduit ces nuisances. Aujourd’hui, les
        installations sont propres. Enfin presque. Selon l’Office fédéral de
        l’environnement, les UIOM helvétiques ont émis près de 2 grammes* de dioxine en
        2020. En 1985, cette quantité était de 250 grammes.
      </>
    )
  },
  {
    illu: require('images/dioxin_02.svg'),
    annotations: [
      {
        text: (
          <>
            <b>La dioxine de Seveso</b> est la plus dangereuse
          </>
        ),
        pos: { x: 15, y: 15 },
        maxWidth: 50,
        align: 'right',
        arrow: {
          type: 'bottom_right',
          pos: { right: '-30px', bottom: '-30px' }
        }
      }
    ],
    title: 'L’ADN des dioxines',
    text: (
      <>
        Il y a plusieurs centaines de dioxines. Toutes ne sont pas toxiques. Une
        des plus dangereuses est celle de Seveso, qui porte le nom de la ville
        en Italie où s’est produit un grave accident industriel en 1976. Les
        dioxines forment un groupe de composés chimiquement apparentés: les
        polluants organiques persistants. Elles présentent la même structure de
        base: seuls le nombre et la disposition des atomes de chlore différent.
        Une source de production de dioxines est l’incinérateur de déchets. Ces
        impuretés se créent en quantités infimes lorsque des matières contenant
        du chlore et des substances organiques sont brûlées ensemble. D’autres
        activités peuvent en fabriquer: cimenterie, raffinerie, fabrication de
        papier colorants. La diffusion dans l’air des dioxines est aujourd’hui
        hautement contrôlée. Un maximum de 0,1 nanogramme* par mètre cube
        d’émission peut être émis dans l'air, selon une Ordonnance fédérale. Le
        problème actuel posé par les dioxines n’est plus leur diffusion, mais
        leur accumulation dans l’environnement. Ces molécules sont persistantes
        et vivent des dizaines d’années dans le sol.
      </>
    )
  },
  {
    illu: require('images/dioxin_03.svg'),
    ground: { y: 89.8, color: '#7B7768' },

    annotations: [
      {
        text: (
          <>
            Un rayon de <b>3 kilomètres autour</b> de l’incinérateur
          </>
        ),
        pos: { x: 30, y: 65 },
        maxWidth: 30,
        arrow: { type: 'right_top', pos: { left: 0, top: '-30px' } }
      }
    ],
    title: 'Dans les airs et dans le sol',
    text: (
      <>
        Les fumées transportent les dioxines et les diffusent dans la nature. Le
        rayon d’action est estimé à 3 kilomètres autour de la source d’émission.
        Cette distance varie en fonction de la rose des vents, de la
        topographie. Les experts estiment que toute zone autour d’un
        incinérateur est à risques. L’évaluation du danger se fait au cas par
        cas. Est-ce un lieu densément peuplé? Une région agricole? Une place de
        jeux pour enfants touchée est ainsi placée en zone rouge. En revanche,
        un terrain peu fréquenté en montagne pose moins un problème de santé
        publique.
      </>
    )
  },
  {
    illu: require('images/dioxin_04.svg'),
    annotations: [
      {
        text: (
          <>
            <b>100 et 1000</b> nanogrammes de dioxines
          </>
        ),
        pos: { x: 20, y: 4 },
        maxWidth: 30,
        align: 'right',
        arrow: {
          type: 'bottom_right',
          pos: { right: '-30px', bottom: '-30px' }
        }
      }
    ],
    title: 'Une persistance crasse',
    text: (
      <>
        La décomposition est lente. Selon le canton de Zurich, il faut plusieurs
        décennies pour que leur quantité soit réduite de moitié. Les émissions
        de la fin du siècle dernier peuvent être toujours présentes. La
        connaissance des sols est ainsi déterminante. Les autorités fédérales
        ont fixé des valeurs limites. Elles varient en fonction de l’utilisation
        du terrain. Pour les places de jeux et les jardins familiaux, l’alerte
        est déclenchée, si ce seuil dépasse les 100 nanogrammes* par mètre cube
        de sol. Pour les terrains agricoles, ce niveau est fixé à 1000
        nanogrammes. Ce sont les cantons qui sont chargés de sonder le terrain,
        de surveiller le niveau des dioxines sur leur territoire. Or, ils sont
        nombreux à ne jamais avoir effectué d’analyses des environs de leurs
        incinérateurs.
      </>
    )
  },
  {
    illu: require('images/dioxin_05.svg'),
    ground: { y: 83, color: '#d1e3d7' },

    annotations: [
      {
        text: (
          <>
            <b>2,5 picogrammes</b> de dioxines par gramme de lait cru (matières
            grasses)
          </>
        ),
        pos: { x: 35, y: 84 },
        maxWidth: 50
        // arrow: {
        //   type: 'top_left',
        //   pos: { left: '-30px', top: '-30px' }
        // }
      }
    ],
    title: 'La chaîne alimentaire',
    text: (
      <>
        C’est la concentration de dioxines qui pose problèmes. Une fois qu’elles
        sont entrées dans la chaîne alimentaire, elles y restent longtemps. Il
        existe des normes très strictes pour les aliments. En Suisse, par
        exemple, un gramme de graisse de lait cru ne peut contenir que 2,5
        picogrammes* (milliardièmes de gramme) de dioxines. Les fruits et
        légumes contaminés doivent être impérativement lavés et pelés avant
        d’être consommés. En revanche, les cucurbitacés (courges, concombres,.
        etc.) sont ingérables. Chez les animaux, les dioxines s’accumulent dans
        les graisses. Leur taux augmente au fil de la chaîne alimentaire. Les
        baleines et autres poissons gras (ombles chevalier, etc.) connaissent un
        fort taux de dioxines. L’homme est en bout de chaîne. Il ingère les
        polluants par le lait, la viande, le poisson, les oeufs.
      </>
    )
  },
  {
    illu: require('images/dioxin_06.svg'),
    annotations: [
      {
        text: (
          <>
            <b>1,75 picogramme</b> de dioxines par kilogramme de poids corporel
            par jour
          </>
        ),
        pos: { x: 3, y: 3 },
        maxWidth: 33,
        align: 'right'
      }
    ],
    title: 'Une exposition chronique',
    text: (
      <>
        Il est impossible de se prémunir totalement contre les dioxines. Selon
        un rapport fédéral, la population suisse ingère quotidiennement, à son
        insu, 1,75 picogramme* de dioxines par kilogramme de poids corporel.
        Cela correspond à six fois la quantité jugée tolérable par l'Autorité
        européenne de sécurité des aliments. L’ingestion de petites quantités de
        substances sur le long terme peut provoquer des maladies chroniques,
        voire certaines formes de cancer. Les dioxines peuvent également
        endommager les systèmes nerveux et immunitaire et affecter l'équilibre
        hormonal et la reproduction. Les effets sur le corps humain restent
        encore méconnus. Ce qui ne facilite pas le travail de prévention des
        autorités.
      </>
    )
  }
]
